
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { TaskflowModel } from './Entities.GormCrm.Taskflow';
import { Model, ModelProperty } from 'models/Model';


export class TaskflowDtoModel extends Model<TaskflowDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'taskflow', type: 'TaskflowModel', languageString: 'taskflowDto.property.taskflow', isHidden: true, isObject: true, new: () => { return new TaskflowModel }, properties: () => { return TaskflowModel.classProperties } },
		{ name: 'productPlanIds', type: 'string[]', languageString: 'taskflowDto.property.productPlanIds', isArray: true },
		{ name: 'productPlanId', type: 'guid', languageString: 'taskflowDto.property.productPlanId' },
		{ name: 'title', type: 'string', languageString: 'taskflowDto.property.title' },
		{ name: 'description', type: 'string', languageString: 'taskflowDto.property.description' },
		{ name: 'deadline', type: 'Date', languageString: 'taskflowDto.property.deadline' },
		{ name: 'userId', type: 'guid', languageString: 'taskflowDto.property.userId' }
	];
	[key: string]: any;
	
	public taskflow?: TaskflowModel;
	public productPlanIds: string[];
	public productPlanId?: string;
	public title: string;
	public description: string;
	public deadline?: Date;
	public userId?: string;
    
	constructor(){
		super();
		this.taskflow = undefined;
		this.productPlanIds = [];
		this.productPlanId = undefined;
		this.title = '';
		this.description = '';
		this.deadline = undefined;
		this.userId = undefined;
		
	}
	getProperties(){
		return TaskflowDtoModel.classProperties;
	}
}

